/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System FindNearest Icon component.
 */
export const SystemFindNearestIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SystemFindNearestIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M11.5 20.596a7.897 7.897 0 100-15.795 7.897 7.897 0 000 15.795z'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
        <path d='M11.5 16.013a3.314 3.314 0 100-6.629 3.314 3.314 0 000 6.629zM11.5 4.3V2M11.5 23v-2.3M3.3 12.5H1M22 12.5h-2.3'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
